export const createUnityPlayerInstanceSlice = (set: Function) => ({
  unityPlayerInstance: null,
  unityPlayerCanvasIsBeingUsed: false,
  unityPlayerCanvas: {
    canvasIsBeingUsed: false,
    viewerCanvasRef: null,
    viewerCanvasBuilt: null,
  },
  setUnityPlayerInstance: (unityPlayerInstance: any) => set((state: any) => ({unityPlayerInstance})),
  setUnityPlayerCanvasIsBeingUsed: (isBeingUsed: boolean) => set((state: any) => ({...state, unityPlayerCanvasIsBeingUsed: isBeingUsed})),

})
